export function withHttp(url: string): string {
  return !/^https?:\/\/|^mailto:/i.test(url) ? `http://${url}` : url;
}

export function isValidUrl(text: string): boolean {
  try {
    const url = new URL(text);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
